import { useEffect } from 'react'
import { toast } from 'sonner'
import { useNavigate } from '@tanstack/react-router'
import { LOGOUT_EVENT } from '@/constants/events'
import { logout as logoutStorage } from '@/utils/auth'
import { resetAllStores } from '@/store'
import { clearUa } from '@/utils/sip'

const useLogoutListener = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const eventHandler = (ev) => {
      const detail = ev.detail || {}

      logoutStorage()
      resetAllStores()
      clearUa()
      navigate({ to: '/login' })
      if (detail.isExpired) {
        toast.error('Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!')
      }
    }
    document.addEventListener(LOGOUT_EVENT, eventHandler)
    return () => document.removeEventListener(LOGOUT_EVENT, eventHandler)
  }, [navigate])
}

export const logout = (isExpired = false) => {
  const ev = new CustomEvent(LOGOUT_EVENT, { detail: { isExpired } })
  document.dispatchEvent(ev)
}

export default useLogoutListener
